import RestApi from './RestApi';

class ChartsClient {

    static getChartStatuses(employeeID) {
      const api = new RestApi();
      return api.GET('/charts/GetChartStatuses?employeeID=' + encodeURIComponent(employeeID)).then(response => {
        return response;
      });
    }

    static getChartsInEmployeeQueue(employeeID) {
      const api = new RestApi();
      return api.GET('/charts/ChartsInEmployeeQueue?employeeID=' + encodeURIComponent(employeeID)).then(response => {
        return response;
      });
    }

    static getAllActiveChartsForBase(copaBase) {
      const api = new RestApi();
      return api.GET('/charts/GetActiveChartsForBase?copaBase=' + encodeURIComponent(copaBase)).then(response => {
        return response;
      });
    }

    static getAllActiveCharts(employeeID) {
        const api = new RestApi();
        return api.GET('/charts/GetAllActiveCharts?employeeID=' + encodeURIComponent(employeeID)).then(response => {
          return response;
        });
      }

    static getChartPDF(chartID,appName,username,caseNumber,integration) {
        const api = new RestApi();
        return api.GET('/charts/GetChartPDF?chartID=' + encodeURIComponent(chartID) + '&appName='+ encodeURIComponent(appName) + '&username='+ encodeURIComponent(username) + '&caseNumber='+ encodeURIComponent(caseNumber) + '&integration='+ encodeURIComponent(integration)).then(response => {
          return response;
        });
      }

      static getChartDetails(chartID,integration) {
        const api = new RestApi();
        return api.GET('/charts/GetChartDetails?chartID=' + encodeURIComponent(chartID) + '&integration='+ encodeURIComponent(integration)).then(response => {
          return response;
        });
      }

    static getAllChartQuestions(chartKey) {
        const api = new RestApi();
        return api.GET('/charts/GetChartQuestions?chartKey=' + encodeURIComponent(chartKey)).then(response => {
          return response;
        });
      }

    static updateChartStatus(payload) {
        const api = new RestApi();
        return api.PUT('/charts/updateChartStatus', payload).then(response => {
          return response;
        });
      }

    static exitChartFromReview(PCR_ID) {
      const api = new RestApi();
      return api.DELETE('/charts/exitChartFromReview?PCR_ID=' + encodeURIComponent(PCR_ID)).then(response => {
        return response;
      });
    }
      
    static submitFormAnswers(payload) {
      const api = new RestApi();
      return api.POST('/charts/SubmitForm', payload).then(response => {
        return response;
      });
    }

}
    
export default ChartsClient;